import { Controller } from "@hotwired/stimulus";

// Remembers whether a native <details> is open or closed across visits,
// keyed by keyValue, in localStorage. If no value is stored yet it keeps
// the server-rendered default. Storage failures (private mode, quota) are
// swallowed so the page never breaks.
export default class extends Controller {
  static values = { key: String };

  connect() {
    const stored = this.#read();
    if (stored === "open") this.element.open = true;
    else if (stored === "closed") this.element.open = false;
  }

  save() {
    this.#write(this.element.open ? "open" : "closed");
  }

  #storageKey() {
    return `agents:desk:${this.keyValue}`;
  }

  #read() {
    try {
      return window.localStorage.getItem(this.#storageKey());
    } catch {
      return null;
    }
  }

  #write(value) {
    try {
      window.localStorage.setItem(this.#storageKey(), value);
    } catch {
      // storage unavailable; remembering is best-effort
    }
  }
}
